import { ICustomerCardsRepository } from 'modules/customer/domain/repositories';
import {
  IVectisTokenizedCard,
  TokenizedCard,
} from 'modules/customer/infra/adapters';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

type TUpdateParams = Parameters<ICustomerCardsRepository['update']>[0];

type TUpdateResponse = {
  statusTransacaoValidacao?: 'AUTORIZADO' | 'REJEITADO' | 'NAO_REALIZADO';
  statusAlteracaoCartao?: 'SUCESSO' | 'ERRO';
  msg?: string;
};

export default class VectisCustomerCardsRepository
  implements ICustomerCardsRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public findAll: ICustomerCardsRepository['findAll'] = async ({
    customerId,
    unitId,
    contractId,
  }) => {
    const cards = await this.httpProvider.get<IVectisTokenizedCard[]>(
      `/clientes/${customerId}/metodosPagamento`,
      {
        params: {
          idUnidade: unitId,
          idContrato: contractId,
        },
      },
    );

    return cards.map(card => new TokenizedCard(card));
  };

  public update: ICustomerCardsRepository['update'] = async params => {
    const url = this.getUpdateUrl(params);
    const body = this.getUpdateBody(params);

    const {
      statusTransacaoValidacao,
      statusAlteracaoCartao,
      msg = '',
    } = await this.httpProvider.post<TUpdateResponse>(url, {
      nomeImpressoCartao: params.card.name,
      dataValidade: params.card.expiry,
      bandeira: params.card.flag,
      numeroCartao: params.card.number,
      codigoSeguranca: params.card.cvc,
      ...body,
    });

    if (statusAlteracaoCartao === 'ERRO') throw new Error(msg);

    return {
      pendenciesCharged: statusTransacaoValidacao === 'AUTORIZADO',
    };
  };

  private getUpdateUrl(params: TUpdateParams) {
    if (params.process === 'REPARCELING') {
      return `/reparcelamentoContrato/trocaCartao/${params.hash}`;
    }

    return `contratos/${params.contractId}/trocaCartao/confirmacao`;
  }

  private getUpdateBody(params: TUpdateParams) {
    if (params.process === 'REPARCELING') {
      return {
        origem: 'SISTEMA',
      };
    }

    return {
      origem: 'SITE_AREA_CLIENTE',
      cobrarParcelasRetroativasPendentes: params.chargePendencies || false,
    };
  }
}
